import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  additionalFieldsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'dashboardService',
    'additionalFieldCrudService',
    '$filter',
    '$state',
    'EXT_ICONS',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      dashboardService,
      additionalFieldService,
      $filter,
      $state,
      EXT_ICONS,
      $sce
    ) {
      'use strict';

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;

        return res;
      }

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          var sort2 = $filter('reflect')(b, column.sortExpression);

          if (sort1 === undefined) sort1 = '';
          if (sort2 === undefined) sort2 = '';
          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          var value2 = $filter('reflect')(b, column.expression);

          if (value1 === undefined) value1 = '';
          if (value2 === undefined) value2 = '';
          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        return column.sortExpression !== undefined
          ? $filter('reflect')(a, column.sortExpression) -
              $filter('reflect')(b, column.sortExpression)
          : $filter('reflect')(a, column.expression) -
              $filter('reflect')(b, column.expression);
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        var firstSplit = firstDate.split('/');
        var secSplit = secDate.split('/');
        firstDate = Date.parse(
          firstSplit[2] + '-' + firstSplit[1] + '-' + firstSplit[0]
        );
        secDate = Date.parse(
          secSplit[2] + '-' + secSplit[1] + '-' + secSplit[0]
        );
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function loadAdditionalFields() {
        additionalFieldService
          .list()
          .then((res) => ($scope.additionalFields = res));
      }

      function isNumberField() {
        var fieldTypes = [2, 4];
        return (
          $scope.additionalField &&
          fieldTypes.includes($scope.additionalField.idFieldType)
        );
      }

      function isTextField() {
        var fieldTypes = [3, 5];
        return (
          $scope.additionalField &&
          fieldTypes.includes($scope.additionalField.idFieldType)
        );
      }

      function isTextOrNumberField() {
        return $scope.isNumberField() || $scope.isTextField();
      }

      function isDateField() {
        return (
          $scope.additionalField && $scope.additionalField.idFieldType === 6
        );
      }

      function isBetweenDates() {
        if (!$scope.newForm.dateFilter) return false;
        if (!$scope.newForm.dateFilter.$modelValue) return false;
        var dateFilter = $scope.newForm.dateFilter.$modelValue.value;
        return $scope.isDateField && dateFilter === 3;
      }

      function isListField() {
        return (
          $scope.additionalField && $scope.additionalField.idFieldType === 7
        );
      }

      function formatedDate(date) {
        if (date === undefined) return '-';
        if (!date.contains('T')) return date;
        var result = new Date(Date.parse(date));
        return result.format('dd/mm/yyyy');
      }

      function getIcon(extension) {
        var ext = extension;

        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png" ></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          var pngAdjust = ext === 'png' ? 'style="padding-bottom:1px"' : '';
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px" ' +
            pngAdjust +
            ' ></img>';
        }

        if (this.isSigned) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        if (this.hasLinkedDocuments === true) {
          image +=
            '<img class="linked_doc" src="/assets/images/document_status/linked.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function formatedSize(size) {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var len = size;
        var order = 0;
        while (len >= 1024 && order + 1 < sizes.length) {
          order++;
          len = len / 1024;
        }

        if (len !== undefined && len !== null) {
          return len.toFixed(2).toString() + ' ' + sizes[order];
        }

        return '0 KB';
      }

      function formatedDocumentType(name) {
        return $filter('truncate')(name, 30, '...', true);
      }

      function formatedTitle(title) {
        return $scope.truncateText(title, 40);
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<b>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</b>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<b>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch {}
          if (lastMarkupBegin !== -1) {
            // has an opening anchor tag
            if (lastMarkupEnds === -1) {
              // not having an closing tag
              tempshortenedString = tempshortenedString.slice(
                0,
                lastMarkupBegin
              );
              return tempshortenedString + '... ';
            }
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function formatedDescription(description) {
        var result = description ? description : '';
        return result;
      }

      function sortColumn(column) {
        if (column.sortable !== true) return;

        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };
        $scope.revisions = $scope.revisions.sort(sort);

        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function search() {
        var filter = {};

        if (!$scope.additionalField) return;
        filter.idAddField = $scope.additionalField.id;
        filter.additionalFieldType = $scope.additionalField.idFieldType;

        if ($scope.isTextOrNumberField()) {
          var value = $scope.newForm.value.$modelValue;

          if ($scope.isNumberField() && value && value !== '') {
            var numberFilter = $scope.newForm.numberFilter.$modelValue.value;
            filter.numberFilter = numberFilter;
            filter.value = value;
          }

          if ($scope.isTextField() && value && value !== '') {
            var textFilter = $scope.newForm.textFilter.$modelValue.value;
            filter.textFilter = textFilter;
            filter.value = value;
          }
        }

        if ($scope.isListField()) {
          filter.value = $scope.newForm.value.$modelValue;
        }

        if ($scope.isDateField()) {
          var dateFilter = $scope.newForm.dateFilter.$modelValue.value;
          filter.dateFilterType = dateFilter;
          if ($scope.isBetweenDates()) {
            filter.startDate = $scope.newForm.startDate.$modelValue;
            filter.endDate = $scope.newForm.endDate.$modelValue;
          }
        }

        $scope.revisions = [];
        dashboardService
          .additionalFieldsReport(filter)
          .then((res) => {
            res.forEach((document) => {
              document.Extension = $scope.getIcon(document.Extension);
              document.Description = $scope.formatedDescription(
                document.Description
              );
              document.Title = $scope.formatedTitle(document.Title);
              document.Date = $scope.formatedDate(document.Date);
              document.Size = $scope.formatedSize(document.Size);
            });

            $scope.revisions = res;
            filter.reportType = 7;
            $scope.filter = filter;
          })
          .catch(() => {});
      }

      function selectedAdditionalField(value) {
        if (arguments.length === 0) return $scope.additionalField;
        $scope.value = '';
        $scope.additionalField = value;
        $scope.revisions = [];
        $scope.columns.pop();
        $scope.columns.push({
          id: 'additionalField',
          header: $scope.additionalField.name,
          expression: 'Value',
          style: {
            'min-width': '100px',
          },
          mobileShow: false,
          visible: true,
          dataPriority: 6,
          disabled: false,
          sortable: true,
          type: 'text',
        });

        if ($scope.additionalField.idFieldType === 7) {
          dashboardService
            .additionalFieldListItems($scope.additionalField.id)
            .then((res) => {
              $scope.listOptions = res;
              $scope.value = res[0];
            })
            .catch(() => {});
        }
      }

      function saveAsPdf() {
        if (!$scope.filter) return;

        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });
        dashboardService
          .generateAdditionalFieldReport($scope.filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function run() {
        try {
          $scope.filter;
          $scope.revisions = [];
          $scope.columns = [];
          $scope.additionalFields = [];
          $scope.additionalField;
          $scope.numberFilters = [
            {
              key: '=',
              value: 0,
            },
            {
              key: '>=',
              value: 1,
            },
            {
              key: '<=',
              value: 2,
            },
          ];
          $scope.numberFilter = {
            key: '=',
            value: 0,
          };
          $scope.textFilters = [
            { key: 'Exatamente', value: 0 },
            { key: 'Contendo', value: 1 },
          ];
          $scope.textFilter = { key: 'Exatamente', value: 0 };
          $scope.dateFilters = [
            {
              key: 'Hoje',
              value: 0,
            },
            {
              key: '1 semana atrás',
              value: 1,
            },
            {
              key: '1 mês atrás',
              value: 2,
            },
            {
              key: 'Entre datas',
              value: 3,
            },
          ];
          $scope.dateFilter = {
            key: 'Hoje',
            value: 0,
          };
          $scope.startDate;
          $scope.endDate;
          $scope.listOptions = [];

          $scope.loadAdditionalFields = logWrapper(
            loadAdditionalFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isNumberField = logWrapper(
            isNumberField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isTextField = logWrapper(
            isTextField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isTextOrNumberField = logWrapper(
            isTextOrNumberField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isDateField = logWrapper(
            isDateField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isBetweenDates = logWrapper(
            isBetweenDates,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isListField = logWrapper(
            isListField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDate = logWrapper(
            formatedDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getIcon = logWrapper(
            getIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedSize = logWrapper(
            formatedSize,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDocumentType = logWrapper(
            formatedDocumentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedTitle = logWrapper(
            formatedTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.truncateText = logWrapper(
            truncateText,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDescription = logWrapper(
            formatedDescription,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumn = logWrapper(
            sortColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.search = logWrapper(
            search,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedAdditionalField = logWrapper(
            selectedAdditionalField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );

          $rootScope.$broadcast('clearSearchTerm');

          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];

          $scope.title = '';
          $scope.description = '';
          $scope.searchTerm = '';

          $scope.columns = [
            {
              id: 'icon',
              width: '50',
              header: $filter('translate')('COLUMN.ICON'),
              expression: 'Extension',
              style: {
                padding: '10px 10px 10px 26px',
                'text-overflow': 'clip',
                'max-width': '50px',
              },
              hideHeader: true,
              visible: true,
              disabled: false,
              dataPriority: 1,
            },
            {
              id: 'code',
              //width: '75',
              header: $filter('translate')('COLUMN.CODE'),
              style: {
                'min-width': '40px',
              },
              expression: 'Code',
              sortExpression: 'Code',
              mobileShow: false,
              dataPriority: 3,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'title',
              width: '35%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'Title',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'Title',
              tooltip: 'tooltipTitle()',
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'author',
              //width: '25%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'Author.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'folder',
              //width: '80',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'Folder.Name',
              sortExpression: 'Folder.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 3,
              sortable: true,
              disabled: true,
              type: 'text',
            },
            {
              id: 'size',
              //width: '110px',
              header: $filter('translate')('COLUMN.SIZE'),
              expression: 'Size',
              style: {
                'min-width': '100px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: false,
              type: 'number',
            },
            {
              id: 'additionalField',
              header: 'Campo Adicional',
              expression: 'Value',
              style: {
                'min-width': '100px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
          ];

          if ($state.params.id) {
            $scope.idfolder = parseInt($state.params.id);
          }

          $scope.noDocuments = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS')
            : $filter('translate')('NO FOLDER SELECTED');
          $scope.noDocumentsMessage = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS MSG')
            : $filter('translate')('NO FOLDER SELECTED MSG');

          $scope.groups = null;

          $scope.loadAdditionalFields();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
